<i *ngIf="icon" class="ca-nav-item-icon f-i f-i-md" [ngClass]="icon || ''"></i>

<span *ngIf="iconText" class="ca-nav-item-icon">
  <span class="ca-nav-item-icon-text"> {{ iconText }}</span>
</span>

<span *ngIf="!icon && !iconText" class="ca-nav-item-icon"></span>
